<template>
    <div>
        <limitless-page-header :loading="busy_loading" :title="'Dokumentkategorier'" :sub-title="category_name" :title-id="category_id">
            <template #header-elements>
                <limitless-page-header-button url="/documents/categories" icon="icon-circle-left2">Tillbaka</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <tb-skeleton v-if="busy_loading" :height="100" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>

            <div v-else-if="!busy_loading && category">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="card">
                            <div class="card-body">
                                <ValidationObserver ref="categoryform">
                                    <form @submit.prevent="saveCategory">
                                        <div class="row">
                                            <label class="col-form-label col-lg-2">Namn: <span class="text-danger">*</span></label>
                                            <div class="col-lg-10">
                                                <input-with-validation
                                                    vid="name"
                                                    label="Namn"
                                                    rules="required"
                                                    v-model="category.name"
                                                    hide-label
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </ValidationObserver>
                            </div>
                            <div class="card-footer">
                                <div class="d-flex justify-content-end">
                                    <limitless-button v-if="category.id !== ''" ref="btndeletecategory" type="button" @click="deleteCategory" :busy="busy_saving" icon="icon-cross2" btn-class="btn-danger" class="mr-auto">RADERA</limitless-button>
                                    <limitless-button ref="btnsavecategory" type="button" @click="saveCategory" :busy="busy_saving" icon="icon-floppy-disk">SPARA</limitless-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import Vue from 'vue';
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import getError from '@services/ErrorHelper';
import InputWithValidation from '@components/Form/InputWithValidation.vue';

export default {
    name: 'DocumentCategoryEdit',
    components: {
        InputWithValidation,
        LimitlessButton,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
    },
    props: {
        id: {
            type: [String, Number],
            default: 0,
        },
    },
    data: () => ({
        busy_loading: true,
        busy_saving: false,
        category: null,
    }),
    mounted() {
        this.init();
    },
    watch: {
        id() {
            this.init();
        },
    },
    methods: {
        init() {
            this.getCategory();
        },
        getCategory() {
            const vm = this;
            vm.busy_loading = true;
            apiClient.get('/vue/documents/categories/' + this.id + '')
                .then((response) => {
                    vm.category = response.data.document_category;
                })
                .finally(() => {
                    vm.busy_loading = false;
                });
        },
        async saveCategory() {
            const vm = this;
            const isValid = await this.$refs.categoryform.validate();
            if (isValid) {
                vm.busy_saving = true;
                await apiClient.post('/vue/documents/categories/' + vm.id, vm.category)
                    .then((response) => {
                        if (parseInt(vm.id, 10) !== parseInt(response.data.document_category.id, 10)) {
                            window.location.href = '/documents/categories/' + response.data.document_category.id;
                        }
                        vm.category = response.data.document_category;
                        vm.$refs.btnsavecategory.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            vm.$refs.categoryform.setErrors(parsederror);
                        }
                        vm.$refs.btnsavecategory.triggerFailed();
                    })
                    .finally(() => {
                        vm.busy_saving = false;
                    });
            }
        },
        deleteCategory() {
            const vm = this;
            // eslint-disable-next-line no-restricted-globals,no-alert
            if (confirm('Are you sure you want to delete this category?')) {
                vm.busy_saving = true;
                apiClient.delete('/vue/documents/categories/' + this.id)
                    .then(() => {
                        window.location.href = '/documents/categories';
                        Vue.set(vm, 'busy_saving', false);
                    })
                    .catch(() => {
                        vm.$refs.btndeletecategory.triggerFailed();
                    })
                    .finally(() => {
                        vm.busy_saving = false;
                    });
            }
        },
        inputFileChanged(files) {
            this.files = files;
        },
    },
    computed: {
        category_name() {
            return (this.category && this.category.id > 0 ? this.category.title : 'New category');
        },
        category_id() {
            return (this.category && this.category.id > 0 ? this.category.id : '');
        },
    },
};

</script>
